import { 
  FaToilet, FaWheelchair, FaShower, FaTint, FaWifi, 
  FaFireAlt, FaCaravan, FaCampground, FaBolt, FaSwimmingPool, 
  FaHome, FaTrash, FaDog, FaMoon, FaDollarSign, 
  FaSwimmer, FaFish, FaShip, FaWater, FaBicycle, FaHiking, 
  FaMotorcycle, FaParking, FaBeer,
  FaLeaf, FaMountain, FaBinoculars, FaHorse, FaChair, FaTable,
  FaWrench, FaPhoneAlt, FaUmbrellaBeach, FaUtensils, 
  FaCoffee, FaGlassWhiskey, FaGasPump, FaClock,
  FaTv, FaBan, FaHotel, FaCar, FaThermometerHalf,
  FaTools, FaRoad, FaSignal, FaUmbrella, FaStore,
  FaConciergeBell, FaRecycle, FaWeight, FaUsers
} from 'react-icons/fa';
import { GiCampingTent, GiWoodCabin, GiWaterfall, GiTreehouse, GiCampfire } from 'react-icons/gi';
import {
  GiWashingMachine, GiIceCube,
  GiGasStove, GiPhotoCamera, GiRiver, GiPathDistance
} from 'react-icons/gi';

import { BiSignal5 } from 'react-icons/bi';
import { MdKitchen, MdLocalLaundryService } from 'react-icons/md';

// Feature interface
interface CampsiteFeature {
  id: number;
  name: string;
  iconSrc?: string;
  Icon: React.ComponentType<any>;
  primary?: boolean;
}

const topCampsiteFeatures: CampsiteFeature[] = [
  { id: 1, name: "Toilets", iconSrc: "toilets.png", Icon: FaToilet, primary: true },
  { id: 2, name: "Accessible", iconSrc: "accessible.png", Icon: FaWheelchair, primary: true },
  { id: 3, name: "Showers", iconSrc: "showers.png", Icon: FaShower, primary: true },
  { id: 4, name: "Drinking Water", iconSrc: "drinking-water.png", Icon: FaTint, primary: true },
  { id: 7, name: "WiFi Internet", iconSrc: "wifi-internet.png", Icon: FaWifi, primary: true },
  { id: 9, name: "BBQ", iconSrc: "bbq.png", Icon: FaFireAlt, primary: true },
  { id: 12, name: "Caravans", iconSrc: "caravans.png", Icon: FaCaravan, primary: true },
  { id: 14, name: "Tent Site", iconSrc: "tent-site.png", Icon: GiCampingTent, primary: true },
  { id: 15, name: "Power", iconSrc: "power.png", Icon: FaBolt, primary: true },
  { id: 16, name: "Swimming Pool", iconSrc: "swimming-pool.png", Icon: FaSwimmingPool, primary: true },
  { id: 19, name: "Cabins", iconSrc: "cabins.png", Icon: GiWoodCabin, primary: true },
  { id: 20, name: "Dump Point", iconSrc: "dump-point.png", Icon: FaTrash, primary: true },
  { id: 22, name: "Pets Welcome", iconSrc: "pets-welcome.png", Icon: FaDog, primary: true },
  { id: 29, name: "Free Overnight Camp", iconSrc: "overnight-rest.png", Icon: FaMoon, primary: true },
  { id: 42, name: "Camping Fee", iconSrc: "camping-fee.png", Icon: FaDollarSign, primary: true },
  { id: 56, name: "Fire Place", iconSrc: "fire-place.png", Icon: FaFireAlt, primary: true },
  { id: 77, name: "Swimming", iconSrc: "swimming.png", Icon: FaSwimmer, primary: true },
  { id: 78, name: "Fishing Spot", iconSrc: "fishing.png", Icon: FaFish, primary: true },
  { id: 91, name: "Public Boat Ramp", iconSrc: "boat-ramp.png", Icon: FaShip, primary: true },
  { id: 140, name: "Canoeing Kayaking", iconSrc: "canoeing-kayaking.png", Icon: FaWater, primary: true },
  
  // New features (non-primary)
  { id: 150, name: "Biking Trails", iconSrc: "biking-trails.png", Icon: FaBicycle },
  { id: 151, name: "Hiking Trails", iconSrc: "hiking-trails.png", Icon: FaHiking },
  { id: 152, name: "Beach Access", iconSrc: "beach-access.png", Icon: FaUmbrellaBeach },
  { id: 153, name: "Motorcycle Access", iconSrc: "motorcycle-access.png", Icon: FaMotorcycle },
  { id: 154, name: "Parking", iconSrc: "parking.png", Icon: FaParking },
  { id: 155, name: "Store", iconSrc: "store.png", Icon: FaStore },
  { id: 156, name: "Bar", iconSrc: "bar.png", Icon: FaBeer },
  { id: 157, name: "Nature Trails", iconSrc: "nature-trails.png", Icon: FaLeaf },
  { id: 158, name: "Mountain Views", iconSrc: "mountain-views.png", Icon: FaMountain },
  { id: 159, name: "Wildlife Watching", iconSrc: "wildlife-watching.png", Icon: FaBinoculars },
  { id: 160, name: "Horse Riding", iconSrc: "horse-riding.png", Icon: FaHorse },
  { id: 161, name: "Campfires Allowed", iconSrc: "campfires-allowed.png", Icon: GiCampfire },
  { id: 162, name: "Picnic Tables", iconSrc: "picnic-tables.png", Icon: FaTable },
  { id: 163, name: "Waterfalls", iconSrc: "waterfalls.png", Icon: GiWaterfall },
  { id: 164, name: "Treehouses", iconSrc: "treehouses.png", Icon: GiTreehouse },
  { id: 165, name: "Camping Chairs", iconSrc: "camping-chairs.png", Icon: FaChair },
  { id: 166, name: "Laundromat", Icon: MdLocalLaundryService },
  { id: 167, name: "Mobile Phone Coverage", Icon: BiSignal5 },
  { id: 169, name: "Ice Available", Icon: GiIceCube },
  { id: 170, name: "LPG Refills", Icon: GiGasStove },
  { id: 171, name: "Maximum Stay", Icon: FaClock },
  { id: 172, name: "Generators Allowed", Icon: FaBolt },
  { id: 173, name: "Photo Opportunity", Icon: GiPhotoCamera },
  { id: 174, name: "Hot Showers", Icon: FaThermometerHalf },
  { id: 175, name: "TV Reception", Icon: FaTv },
  { id: 176, name: "No Fires", Icon: FaBan },
  { id: 177, name: "Coffee & Tea", Icon: FaCoffee },
  { id: 178, name: "Cold Drinks", Icon: FaGlassWhiskey },
  { id: 179, name: "Public Phone", Icon: FaPhoneAlt },
  { id: 180, name: "Non Drinking Water", Icon: FaTint },
  { id: 181, name: "River Access", Icon: GiRiver },
  { id: 182, name: "Rough Road", Icon: FaRoad },
  { id: 183, name: "Takeaway Food", Icon: FaUtensils },
  { id: 184, name: "Fuel Available", Icon: FaGasPump },
  { id: 185, name: "No Caravans", Icon: FaBan },
  { id: 186, name: "Shade Available", Icon: FaUmbrella },
  { id: 187, name: "Kitchen Facilities", Icon: MdKitchen },
  { id: 188, name: "Waste Disposal", Icon: FaRecycle },
  { id: 189, name: "Vehicle Length Limit", Icon: GiPathDistance },
  { id: 190, name: "Maintenance", Icon: FaTools },
  // US (EscapeTo / OSM feed) canonical features that otherwise fall through
  // to the generic default icon.
  { id: 191, name: "Motorhomes", Icon: FaCaravan },
  { id: 192, name: "Backcountry", Icon: FaMountain },
  { id: 193, name: "Campfire", Icon: GiCampfire },
  { id: 194, name: "Shower", Icon: FaShower },
  // Listing-enrichment canonical features (notes/seasons)
  { id: 195, name: "Unpowered Sites", Icon: GiCampingTent, primary: false },
  { id: 196, name: "Dogs Welcome (On Lead)", Icon: FaDog, primary: false },
  { id: 197, name: "Traditional Owner Managed", Icon: FaUsers, primary: false },
  { id: 198, name: "Crocodile Risk — No Swimming", Icon: FaSwimmer, primary: false },
  { id: 199, name: "Marine Stingers", Icon: FaWater, primary: false }
];

// Export the array of feature objects for use in the FeatureIcon component
export default topCampsiteFeatures;

// Helper functions for dealing with features

// Get primary features (those most commonly used)
export const getPrimaryFeatures = (): CampsiteFeature[] => {
  return topCampsiteFeatures.filter(feature => feature.primary === true);
};

// Get feature by name (case-insensitive)
export const getFeatureByName = (name: string): CampsiteFeature | undefined => {
  return topCampsiteFeatures.find(
    feature => feature.name.toLowerCase() === name.toLowerCase()
  );
};

// Get feature by ID
export const getFeatureById = (id: number): CampsiteFeature | undefined => {
  return topCampsiteFeatures.find(feature => feature.id === id);
};

// Check if a feature is a primary feature
export const isPrimaryFeature = (name: string): boolean => {
  const feature = getFeatureByName(name);
  return feature ? !!feature.primary : false;
};

// Get all feature names as an array
export const getAllFeatureNames = (): string[] => {
  return topCampsiteFeatures.map(feature => feature.name);
};

// Group features by category
export const getFeatureCategories = () => {
  return {
    facilities: topCampsiteFeatures.filter(f => 
      ['toilets', 'showers', 'cabins', 'power', 'dump point', 'wifi internet'].some(
        keyword => f.name.toLowerCase().includes(keyword)
      )
    ),
    activities: topCampsiteFeatures.filter(f => 
      ['swimming', 'fishing', 'hiking', 'biking', 'kayaking', 'horse'].some(
        keyword => f.name.toLowerCase().includes(keyword)
      )
    ),
    amenities: topCampsiteFeatures.filter(f => 
      ['bbq', 'kitchen', 'picnic', 'fire', 'store', 'laundromat'].some(
        keyword => f.name.toLowerCase().includes(keyword)
      )
    ),
    accessibility: topCampsiteFeatures.filter(f => 
      ['accessible', 'pets', 'parking', 'caravan'].some(
        keyword => f.name.toLowerCase().includes(keyword)
      )
    ),
    price: topCampsiteFeatures.filter(f => 
      ['free', 'fee', 'cost'].some(
        keyword => f.name.toLowerCase().includes(keyword)
      )
    )
  };
};